import useSwr from 'swr';
import type { SwrReturnType } from '~/models/Api';
import type { MarketInitialCompanySetting } from '~/models/CompanySetting';

const paths = {
  show: '/markets/company_settings'
};

type TShow = () => Omit<SwrReturnType<MarketInitialCompanySetting>, 'mutate'>;
type ReturnType = {
  show: TShow;
};

export const useCompanySettings = (): ReturnType => {
  const show: TShow = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, error } = useSwr(paths.show);
    return {
      data: data ?? null,
      error,
      isLoading: !data && !error
    };
  };
  return { show };
};
